module.exports = __webpack_public_path__ + "img/tube.3a10c2ed.svg";